import React, { useEffect, useState } from 'react';
import styled from 'styled-components';


interface TimeInputProps {
  startTime: string
  setStartTime: (value: string) => void
}

const TimeInput: React.FC<TimeInputProps> = ({ startTime, setStartTime }) => { 

  const seconds = Number(startTime);

  const formatTime = (totalSeconds: number) => {
    if (isNaN(totalSeconds) || totalSeconds < 0) return '';
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const mm = String(minutes).padStart(2, '0');
    const ss = String(seconds).padStart(2, '0');

    return `${mm}:${ss}`;
  };
  const sanitize = (raw: string) => {
    // Оставляем только цифры, вообще никак не подставляя "1" за пользователя.
    const digits = String(raw ?? "").replace(/[^\d]/g, "");
    if (!digits) return "";
    const n = Number.parseInt(digits, 10);
    // При вводе не даём поставить 0/отрицательные — минимум 1, но это уже именно ввод пользователя.
    return String(Number.isFinite(n) ? Math.max(1, n) : "");
  };

  return (
    <Container>
      <Input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="1"
        value={startTime}
        onKeyDown={(e) => {
          // Prevent decimal / scientific notation chars that browsers allow in number-like inputs
          if (e.key === "." || e.key === "," || e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
          e.preventDefault();
          const text = e.clipboardData.getData("text");
          setStartTime(sanitize(text));
        }}
        onChange={(e) => setStartTime(sanitize(e.target.value))}
      />
      <TimeDisplay>{startTime ? formatTime(seconds) : '00:00'}</TimeDisplay>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;  
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

const Input = styled.input`
  font-size: 14px;
  font-family: monospace;   
  border-radius: 6px;
  width: 100%;
  border: none;
  outline: none;   
  color: #00000080;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }            
`;

const TimeDisplay = styled.div`
  font-family: monospace;
  font-size: 16px;
  color: #00000080;
  min-width: 60px;
  text-align: center;
`;
export default TimeInput;
